// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/fonts/dinweb-cond.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/fonts/ucpa-font-v23.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/fonts/ucpa-font-v23.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/fonts/ucpa-font-v23.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../public/fonts/ucpa-font-v23.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#ucpa-font" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: dinweb-cond;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
}

@font-face {
  font-family: "ucpa-font";
  src:url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  src:url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg");
  font-weight: normal;
  font-style: normal;
}

[data-icon]:before {
  font-family: "ucpa-font";
  content: attr(data-icon);
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

[class^="icon-"]:before,
[class*=" icon-"]:before {
  font-family: "ucpa-font";
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  speak: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-mt-4 {
  margin-top: 4px;
}


.icon-users:before {
  content: "\\21";
}
.icon-cancel:before {
  content: "\\22";
}
.icon-phone:before {
  content: "\\23";
}
.icon-shopping-cart:before {
  content: "\\24";
}
.icon-strikethrough:before {
  content: "\\25";
}
.icon-star:before {
  content: "\\26";
}
.icon-minus:before {
  content: "\\27";
}
.icon-filter:before {
  content: "\\29";
}
.icon-minus-1:before {
  content: "\\2a";
}
.icon-familia2-1:before {
  content: "\\2b";
}
.icon-stop:before {
  content: "\\2c";
}
.icon-familia2:before {
  content: "\\2d";
}
.icon-clock-streamline-time:before {
  content: "\\2e";
}
.icon-bill:before {
  content: "\\2f";
}
.icon-multi-button:before {
  content: "\\30";
}
.icon-multi-img:before {
  content: "\\31";
}
.icon-files-o:before {
  content: "\\32";
}
.icon-torsos-all:before {
  content: "\\33";
}
.icon-list:before {
  content: "\\34";
}
.icon-file-text:before {
  content: "\\35";
}
.icon-square-o:before {
  content: "\\36";
}
.icon-columns:before {
  content: "\\37";
}
.icon-list-alt:before {
  content: "\\38";
}
.icon-xcta:before {
  content: "\\39";
}
.icon-logout:before {
  content: "\\3a";
}
.icon-qrcode:before {
  content: "\\3b";
}
.icon-rewind:before {
  content: "\\3c";
}
.icon-newuser:before {
  content: "\\3e";
}
.icon-clock:before {
  content: "\\3f";
}
.icon-torso:before {
  content: "\\40";
}
.icon-file-text-o:before {
  content: "\\41";
}
.icon-newspaper-o:before {
  content: "\\42";
}
.icon-play-circle:before {
  content: "\\43";
}
.icon-plus:before {
  content: "\\44";
}
.icon-pencil-square-o:before {
  content: "\\45";
}
.icon-sort:before {
  content: "\\46";
}
.icon-trash:before {
  content: "\\47";
}
.icon-indent:before {
  content: "\\48";
}
.icon-ctaction-text:before {
  content: "\\49";
}
.icon-s-2img:before {
  content: "\\4a";
}
.icon-text-video:before {
  content: "\\4b";
}
.icon-vignette3:before {
  content: "\\4c";
}
.icon-s-3img:before {
  content: "\\4d";
}
.icon-s-4img:before {
  content: "\\4e";
}
.icon-vignette4:before {
  content: "\\4f";
}
.icon-s-img-text:before {
  content: "\\50";
}
.icon-image-text:before {
  content: "\\51";
}
.icon-image-vignette:before {
  content: "\\52";
}
.icon-slider:before {
  content: "\\53";
}
.icon-slider-img-text:before {
  content: "\\54";
}
.icon-text-block:before {
  content: "\\55";
}
.icon-text-image:before {
  content: "\\56";
}
.icon-text-slider:before {
  content: "\\57";
}
.icon-s-text-img:before {
  content: "\\58";
}
.icon-ctaction:before {
  content: "\\59";
}
.icon-hexagons:before {
  content: "\\5a";
}
.icon-torso-female:before {
  content: "\\5b";
}
.icon-thumbs-up:before {
  content: "\\5c";
}
.icon-camera:before {
  content: "\\5d";
}
.icon-clock-1:before {
  content: "\\5e";
}
.icon-star-o:before {
  content: "\\5f";
}
.icon-star-half-o:before {
  content: "\\60";
}
.icon-safety:before {
  content: "\\61";
}
.icon-add-more-icon:before {
  content: "\\62";
}
.icon-check-icon:before {
  content: "\\63";
}
.icon-date-check-icon:before {
  content: "\\64";
}
.icon-date-refresh-icon:before {
  content: "\\65";
}
.icon-heart-icon:before {
  content: "\\66";
}
.icon-lock-icon:before {
  content: "\\67";
}
.icon-not-check-icon:before {
  content: "\\68";
}
.icon-quotes-icon:before {
  content: "\\69";
}
.icon-safety-icon:before {
  content: "\\6a";
}
.icon-question-icon:before {
  content: "\\6b";
}
.icon-buddy:before {
  content: "\\6c";
}
.icon-angle-down-icon:before {
  content: "\\6d";
}
.icon-angle-left-icon:before {
  content: "\\6e";
}
.icon-angle-right-icon:before {
  content: "\\6f";
}
.icon-angle-up-icon:before {
  content: "\\70";
}
.icon-facebook:before {
  content: "\\71";
}
.icon-twitter:before {
  content: "\\72";
}
.icon-instagram:before {
  content: "\\73";
}
.icon-pinterest:before {
  content: "\\74";
}
.icon-youtube:before {
  content: "\\75";
}
.icon-circle-icon:before {
  content: "\\76";
}
.icon-list-icon:before {
  content: "\\77";
}
.icon-mosaic-icon:before {
  content: "\\78";
}
.icon-times:before {
  content: "\\79";
}
.icon-pin:before {
  content: "\\7a";
}
.icon-loader:before {
  content: "\\7b";
}
.icon-gift:before {
  content: "\\7c";
}
.icon-at:before {
  content: "\\7d";
}
.icon-attention:before {
  content: "\\7e";
}
.icon-search:before {
  content: "\\7f";
}
.icon-review:before {
  content: "\\e000";
}
.icon-calendar:before {
  content: "\\e001";
}
.icon-newspaper:before {
  content: "\\e002";
}
.icon-upload:before {
  content: "\\e003";
}
.icon-check:before {
  content: "\\e004";
}
.icon-refresh:before {
  content: "\\e005";
}
.icon-ticket:before {
  content: "\\e006";
}
.icon-id-card:before {
  content: "\\e007";
}
.icon-pass:before {
  content: "\\e008";
}
.icon-banknote:before {
  content: "\\e009";
}
.icon-chevron-down:before {
  content: "\\e00a";
}
.icon-chevron-left:before {
  content: "\\e00b";
}
.icon-chevron-right:before {
  content: "\\e00c";
}
.icon-chevron-up:before {
  content: "\\e00d";
}
.icon-tiktok:before {
  content: "\\e900";
}
.icon-pencil:before {
  content: "\\e905";
}
.icon-arrow-left2:before {
  content: "\\ea40";
  vertical-align: sub;
}
.icon-new-tab:before {
  content: "\\ea7e";
}
.icon-linkedin:before {
  content: "\\eac9";
}`, "",{"version":3,"sources":["webpack://./styles/icons.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,2DAA8D;AAChE;;AAEA;EACE,wBAAwB;EACxB,2CAA+C;EAC/C;;;yDAGqE;EACrE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,WAAW;EACX,cAAc;EACd,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;EAEE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,WAAW;EACX,cAAc;EACd,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["@font-face {\n  font-family: dinweb-cond;\n  src: url(\"../../public/fonts/dinweb-cond.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"ucpa-font\";\n  src:url(\"../../public/fonts/ucpa-font-v23.eot\");\n  src:url(\"../../public/fonts/ucpa-font-v23.eot?#iefix\") format(\"embedded-opentype\"),\n    url(\"../../public/fonts/ucpa-font-v23.woff\") format(\"woff\"),\n    url(\"../../public/fonts/ucpa-font-v23.ttf\") format(\"truetype\"),\n    url(\"../../public/fonts/ucpa-font-v23.svg#ucpa-font\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n[data-icon]:before {\n  font-family: \"ucpa-font\";\n  content: attr(data-icon);\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  speak: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n[class^=\"icon-\"]:before,\n[class*=\" icon-\"]:before {\n  font-family: \"ucpa-font\";\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  speak: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-mt-4 {\n  margin-top: 4px;\n}\n\n\n.icon-users:before {\n  content: \"\\21\";\n}\n.icon-cancel:before {\n  content: \"\\22\";\n}\n.icon-phone:before {\n  content: \"\\23\";\n}\n.icon-shopping-cart:before {\n  content: \"\\24\";\n}\n.icon-strikethrough:before {\n  content: \"\\25\";\n}\n.icon-star:before {\n  content: \"\\26\";\n}\n.icon-minus:before {\n  content: \"\\27\";\n}\n.icon-filter:before {\n  content: \"\\29\";\n}\n.icon-minus-1:before {\n  content: \"\\2a\";\n}\n.icon-familia2-1:before {\n  content: \"\\2b\";\n}\n.icon-stop:before {\n  content: \"\\2c\";\n}\n.icon-familia2:before {\n  content: \"\\2d\";\n}\n.icon-clock-streamline-time:before {\n  content: \"\\2e\";\n}\n.icon-bill:before {\n  content: \"\\2f\";\n}\n.icon-multi-button:before {\n  content: \"\\30\";\n}\n.icon-multi-img:before {\n  content: \"\\31\";\n}\n.icon-files-o:before {\n  content: \"\\32\";\n}\n.icon-torsos-all:before {\n  content: \"\\33\";\n}\n.icon-list:before {\n  content: \"\\34\";\n}\n.icon-file-text:before {\n  content: \"\\35\";\n}\n.icon-square-o:before {\n  content: \"\\36\";\n}\n.icon-columns:before {\n  content: \"\\37\";\n}\n.icon-list-alt:before {\n  content: \"\\38\";\n}\n.icon-xcta:before {\n  content: \"\\39\";\n}\n.icon-logout:before {\n  content: \"\\3a\";\n}\n.icon-qrcode:before {\n  content: \"\\3b\";\n}\n.icon-rewind:before {\n  content: \"\\3c\";\n}\n.icon-newuser:before {\n  content: \"\\3e\";\n}\n.icon-clock:before {\n  content: \"\\3f\";\n}\n.icon-torso:before {\n  content: \"\\40\";\n}\n.icon-file-text-o:before {\n  content: \"\\41\";\n}\n.icon-newspaper-o:before {\n  content: \"\\42\";\n}\n.icon-play-circle:before {\n  content: \"\\43\";\n}\n.icon-plus:before {\n  content: \"\\44\";\n}\n.icon-pencil-square-o:before {\n  content: \"\\45\";\n}\n.icon-sort:before {\n  content: \"\\46\";\n}\n.icon-trash:before {\n  content: \"\\47\";\n}\n.icon-indent:before {\n  content: \"\\48\";\n}\n.icon-ctaction-text:before {\n  content: \"\\49\";\n}\n.icon-s-2img:before {\n  content: \"\\4a\";\n}\n.icon-text-video:before {\n  content: \"\\4b\";\n}\n.icon-vignette3:before {\n  content: \"\\4c\";\n}\n.icon-s-3img:before {\n  content: \"\\4d\";\n}\n.icon-s-4img:before {\n  content: \"\\4e\";\n}\n.icon-vignette4:before {\n  content: \"\\4f\";\n}\n.icon-s-img-text:before {\n  content: \"\\50\";\n}\n.icon-image-text:before {\n  content: \"\\51\";\n}\n.icon-image-vignette:before {\n  content: \"\\52\";\n}\n.icon-slider:before {\n  content: \"\\53\";\n}\n.icon-slider-img-text:before {\n  content: \"\\54\";\n}\n.icon-text-block:before {\n  content: \"\\55\";\n}\n.icon-text-image:before {\n  content: \"\\56\";\n}\n.icon-text-slider:before {\n  content: \"\\57\";\n}\n.icon-s-text-img:before {\n  content: \"\\58\";\n}\n.icon-ctaction:before {\n  content: \"\\59\";\n}\n.icon-hexagons:before {\n  content: \"\\5a\";\n}\n.icon-torso-female:before {\n  content: \"\\5b\";\n}\n.icon-thumbs-up:before {\n  content: \"\\5c\";\n}\n.icon-camera:before {\n  content: \"\\5d\";\n}\n.icon-clock-1:before {\n  content: \"\\5e\";\n}\n.icon-star-o:before {\n  content: \"\\5f\";\n}\n.icon-star-half-o:before {\n  content: \"\\60\";\n}\n.icon-safety:before {\n  content: \"\\61\";\n}\n.icon-add-more-icon:before {\n  content: \"\\62\";\n}\n.icon-check-icon:before {\n  content: \"\\63\";\n}\n.icon-date-check-icon:before {\n  content: \"\\64\";\n}\n.icon-date-refresh-icon:before {\n  content: \"\\65\";\n}\n.icon-heart-icon:before {\n  content: \"\\66\";\n}\n.icon-lock-icon:before {\n  content: \"\\67\";\n}\n.icon-not-check-icon:before {\n  content: \"\\68\";\n}\n.icon-quotes-icon:before {\n  content: \"\\69\";\n}\n.icon-safety-icon:before {\n  content: \"\\6a\";\n}\n.icon-question-icon:before {\n  content: \"\\6b\";\n}\n.icon-buddy:before {\n  content: \"\\6c\";\n}\n.icon-angle-down-icon:before {\n  content: \"\\6d\";\n}\n.icon-angle-left-icon:before {\n  content: \"\\6e\";\n}\n.icon-angle-right-icon:before {\n  content: \"\\6f\";\n}\n.icon-angle-up-icon:before {\n  content: \"\\70\";\n}\n.icon-facebook:before {\n  content: \"\\71\";\n}\n.icon-twitter:before {\n  content: \"\\72\";\n}\n.icon-instagram:before {\n  content: \"\\73\";\n}\n.icon-pinterest:before {\n  content: \"\\74\";\n}\n.icon-youtube:before {\n  content: \"\\75\";\n}\n.icon-circle-icon:before {\n  content: \"\\76\";\n}\n.icon-list-icon:before {\n  content: \"\\77\";\n}\n.icon-mosaic-icon:before {\n  content: \"\\78\";\n}\n.icon-times:before {\n  content: \"\\79\";\n}\n.icon-pin:before {\n  content: \"\\7a\";\n}\n.icon-loader:before {\n  content: \"\\7b\";\n}\n.icon-gift:before {\n  content: \"\\7c\";\n}\n.icon-at:before {\n  content: \"\\7d\";\n}\n.icon-attention:before {\n  content: \"\\7e\";\n}\n.icon-search:before {\n  content: \"\\7f\";\n}\n.icon-review:before {\n  content: \"\\e000\";\n}\n.icon-calendar:before {\n  content: \"\\e001\";\n}\n.icon-newspaper:before {\n  content: \"\\e002\";\n}\n.icon-upload:before {\n  content: \"\\e003\";\n}\n.icon-check:before {\n  content: \"\\e004\";\n}\n.icon-refresh:before {\n  content: \"\\e005\";\n}\n.icon-ticket:before {\n  content: \"\\e006\";\n}\n.icon-id-card:before {\n  content: \"\\e007\";\n}\n.icon-pass:before {\n  content: \"\\e008\";\n}\n.icon-banknote:before {\n  content: \"\\e009\";\n}\n.icon-chevron-down:before {\n  content: \"\\e00a\";\n}\n.icon-chevron-left:before {\n  content: \"\\e00b\";\n}\n.icon-chevron-right:before {\n  content: \"\\e00c\";\n}\n.icon-chevron-up:before {\n  content: \"\\e00d\";\n}\n.icon-tiktok:before {\n  content: \"\\e900\";\n}\n.icon-pencil:before {\n  content: \"\\e905\";\n}\n.icon-arrow-left2:before {\n  content: \"\\ea40\";\n  vertical-align: sub;\n}\n.icon-new-tab:before {\n  content: \"\\ea7e\";\n}\n.icon-linkedin:before {\n  content: \"\\eac9\";\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
